// Shared constants for the Tables feature (list view + floorplan view)

export const statusConfig = {
  available: { label: 'Available', bgColor: 'bg-signal-ok-line', textColor: 'text-white' },
  occupied: { label: 'Occupied', bgColor: 'bg-signal-stop-line', textColor: 'text-white' },
  reserved: { label: 'Reserved', bgColor: 'bg-signal-info-line', textColor: 'text-white' },
  cleaning: { label: 'Cleaning', bgColor: 'bg-signal-warn-line', textColor: 'text-white' },
};

export const diningStages = [
  { value: 'seated', label: 'Seated' },
  { value: 'ordering', label: 'Ordering' },
  { value: 'awaiting_starters', label: 'Awaiting Starters' },
  { value: 'starters_served', label: 'Starters Served' },
  { value: 'awaiting_mains', label: 'Awaiting Mains' },
  { value: 'mains_served', label: 'Mains Served' },
  { value: 'awaiting_desserts', label: 'Awaiting Desserts' },
  { value: 'desserts_served', label: 'Desserts Served' },
  { value: 'awaiting_bill', label: 'Awaiting Bill' },
  { value: 'bill_paid', label: 'Bill Paid' },
];
